import { REQUIRED_CREDITS } from '../constants/credits';

const sr = {
  inputType: 'Tip unosa:',
  uploadPDF: 'PDF',
  comicDescription: 'Opiši strip',
  comicDescriptionPlaceholder:
    'Radoznala slonica uči da leti uz pomoć svojih prijatelja iz džungle.',
  comicDescriptionErrorMessage: 'Opis mora imati najmanje 10 karaktera. ☝️',
  color: 'Boja:',
  colorVariant: 'Izaberi Boju Šablona',
  generatingDialog: 'Generisanje dijalog-a ...',
  generatePDF: 'Generiši PDF',
  generatingPDF: 'Generisanje PDF-a ...',
  generatedPDF: 'Generisani PDF',
  message: 'Poruka',
  language: 'Zelim strip na jeziku:',
  languageSerbian: 'Srpski',
  languageSlovenian: 'Slovenački',
  languageEnglish: 'Engleski',
  languageSpanish: 'Španski',
  languageFrench: 'Francuski',
  languageRussian: 'Ruski',
  languageItalian: 'Italijanski',
  languageChinese: 'Kineski',
  languageTurkish: 'Turski',
  languageHungarian: 'Mađarski',
  languagePortuguese: 'Portugalski',
  page: 'Stranica:',
  editProfile: 'Uredi profil',
  purchaseTokens: 'Kupi tokene',
  transactions: 'Transakcije',
  help: 'Pomoć',
  transactionHistory: 'Istorija transakcija tokena',
  couldNotLoadTransactions: 'Transakcije nije moguće učitati.',
  noTransactions: 'Još nema transakcija.',
  transactionDate: 'Datum',
  transactionSource: 'Izvor',
  transactionAmount: 'Iznos',
  transactionStatus: 'Status',
  rowsPerPage: 'Redova po strani',
  previous: 'Prethodna',
  next: 'Sledeća',
  pageOf: 'Strana __PAGE__ od __TOTAL__',
  statusCompleted: 'Završeno',
  sourcePurchase: 'Kupovina',
  sourceCoupon: 'Kupon',
  sourceRefund: 'Povraćaj',
  sourceDailyGift: 'Dnevni poklon',
  sourceScicomic: 'SciComic',
  sourceCite: 'Cite',
  helpGetStartedTitle: 'Kako da počneš',
  helpGetStartedStep1:
    'Izaberi da li želiš da otpremiš PDF ili da opišeš ideju za strip.',
  helpGetStartedStep2: 'Podesi jezik i broj stranica pre generisanja dijaloga.',
  helpGetStartedStep3:
    'Pregledaj generisani tekst, po potrebi izmeni poruke, pa zatim napravi finalni PDF.',
  helpWritingTitle: 'Saveti za bolji rezultat',
  helpWritingTip1:
    'Neka opis bude kratak, jasan i fokusiran na jednu glavnu situaciju.',
  helpWritingTip2:
    'Ako želiš precizniji rezultat, navedi ton, likove i okruženje.',
  helpWritingTip3: 'Pre izvoza možeš ručno da doteraš poruke u oblačićima.',
  helpGenerationTitle: 'Saveti za generisanje',
  helpGenerationTip1:
    'Generisanje dijaloga i stripa troši tokene, zato prvo proveri stanje.',
  helpGenerationTip2:
    'Kod jednodelnih stripova koristi kraći tekst da bi oblačići ostali čitki.',
  helpGenerationTip3:
    'Ako rezultat nije dobar, ponovo generiši dijalog ili izmeni tekst pre pravljenja PDF-a.',
  helpContactTitle: 'Treba ti još pomoći?',
  helpContactDescription:
    'Ako naiđeš na problem ili ti treba pomoć oko naloga ili tokena, javi se našem timu za podršku.',
  helpGotIt: 'U redu',
  helpVersion: 'SciComic v1.0',
  selectTokenPackage: 'Izaberite paket tokena',
  individual: 'Pojedinačni',
  professional: 'Profesionalni',
  closePurchaseModal: 'Zatvori kupovinu tokena',
  stripeConfigurationError: 'Kupovina tokena trenutno nije dostupna.',
  redeemCode: 'Iskoristi kod',
  enterCode: 'Unesite kod',
  redeem: 'Potvrdi',
  redeeming: 'Provera koda...',
  cancel: 'Otkaži',
  codeRedeemed: 'Kod je uspešno iskorišćen.',
  codeAlreadyUsed: 'Ovaj kod je već iskorišćen.',
  codeNotFound: 'Kod nije pronađen.',
  failedToRedeem: 'Kod nije moguće iskoristiti.',
  wizardStep: 'Korak',
  wizardSource: 'Izvor i podesavanja',
  wizardScript: 'Scenario',
  wizardImages: 'Slike panela',
  wizardVisualDesign: 'Spremno za generisanje',
  wizardSourceDescription:
    'Dodajte materijal za strip i proverite izabrani jezik.',
  wizardScriptDescription:
    'Pregledajte uvod, kljucne informacije i zakljucak pre nastavka.',
  wizardImagesDescription:
    'Opciono ubacite svoje slike ili opisite sta treba generisati za svaki panel.',
  wizardVisualDescription:
    'Izaberite pozadinsku boju stripa i citljivu boju teksta.',
  sourceQuestion: 'Sta zelite da pretvorite u strip?',
  dropPdf: 'Prevucite PDF ovde ili kliknite da',
  browsePdf: 'izaberete fajl',
  continue: 'Nastavi',
  comicType: 'Tip stripa',
  onePage: 'Jedna strana',
  classicFourPanelTemplate: 'Klasicni strip sa cetiri panela',
  classicFourPanelTemplateDescription:
    'Cist raspored na jednoj strani sa naslovom, cetiri jednake slike i tekstom ispod svake slike.',
  templateTitlePlacement: 'Naslov ide na vrh strane.',
  templateImagePlacement: 'Slike su rasporedjene u mrezi 2 x 2.',
  templateTextPlacement: 'Tekst ide ispod svake slike, ne preko slike.',
  fourPanelStory: 'Priča kroz četiri panela',
  verificationScoreLabel: 'Pouzdanost __SCORE__/100',
  verificationDetailsTitle: 'Provera tačnosti scenarija',
  verificationDetailsDescription:
    'SciComic-ov verification loop je proverio generisanu priču i ona odgovara originalnom tekstu iz PDF-a.',
  verificationDetailSource:
    'Provereno je da brojevi i ključni podaci iz stripa zaista potiču iz originalnog PDF izvora.',
  verificationDetailSourceTooltip:
    'Brojevi, statistike i skraćenice iz scenarija se upoređuju sa originalnim tekstom izvora, kako bi se otkrilo da li strip navodi podatak koji ne postoji u izvoru.',
  verificationDetailClaims:
    'Pregledane su ključne tvrdnje u sva četiri frame-a kako bi ostale verne izvoru.',
  verificationDetailClaimsTooltip:
    'AI proverava da li su tvrdnje u sva četiri panela verne izvornom materijalu, i da strip ne iznosi nešto što izvor ne podržava.',
  verificationDetailLanguage:
    'Provereno je da je scenario napisan na izabranom jeziku.',
  verificationDetailLanguageTooltip:
    'Proverava se da li je ceo tekst dosledno napisan na izabranom jeziku.',
  verificationScoreUnavailableLabel: 'Pouzdanost nije dostupna',
  verificationDetailUnavailable: 'Nije provereno',
  verificationDetailUnavailableTooltip:
    'Ova provera nije mogla da se izvrši za ovaj scenario, pa se ne računa u ukupnu pouzdanost umesto da se tretira kao uspešna.',
  comicTitle: 'Naslov stripa',
  comicTitlePlaceholder: 'Unesite naslov za ovaj strip...',
  defaultComicTitle: 'SciComic',
  panelIntroduction: 'Uvod',
  panelKeyFact: 'Ključna informacija',
  panelExplanation: 'Objašnjenje',
  panelConclusion: 'Zaključak',
  panelTextPlaceholder: 'Napisite jednu kratku i tacnu recenicu...',
  panelImage: 'Slika panela',
  uploadPanelImage: 'Ubacite sliku',
  removePanelImage: 'Ukloni',
  generatedPanelImage: 'Generisana slika',
  panelImagePrompt: 'Prompt za sliku',
  panelImagePromptPlaceholder: 'Opisite kakvu sliku zelite za ovaj panel...',
  panelImagePromptDisabled: 'Slika je učitana, prompt se ne koristi.',
  panelImageOptionalNote:
    'Uploadovana slika ima prednost. Ako nema slike, SciComic koristi vas prompt; ako je prompt prazan, slika se generise iz price panela.',
  previousStep: 'Prethodni korak',
  createScript: 'Napravi scenario',
  workflowError: 'Došlo je do greške. Pokušajte ponovo.',
  frames: 'frame-ova',
  frame: 'Frame',
  emptyFrame: 'Prazan frame',
  sentence: 'Rečenica',
  length: 'Dužina',
  keep: 'Zadrži',
  shorter: 'Kraće',
  longer: 'Duže',
  complexity: 'Složenost',
  simpler: 'Jednostavnije',
  scientific: 'Naučnije',
  tone: 'Ton',
  toneProfessional: 'Profesionalan',
  toneFriendly: 'Prijateljski',
  toneFunny: 'Duhovit',
  rewriteInstruction: 'Instrukcija za ponovno generisanje',
  regenerateSourceDescription: 'Opis stripa',
  selectedPdf: 'Izabrani PDF',
  noPdfSelected: 'PDF nije izabran',
  changePdf: 'Promeni PDF',
  changePdfDescription:
    'Ako promenite PDF, potrebno je da ponovo napravite scenario iz novog fajla.',
  rewriteInstructionPlaceholder:
    'Opišite šta treba promeniti u ovom frame-u...',
  regenerateFrame: 'Ponovo generiši frame',
  comicBackgroundColor: 'Pozadinska boja stripa',
  comicBackgroundColorDescription:
    'Podesite boju stranice iza naslova, slika i teksta.',
  comicTextColor: 'Boja slova',
  comicTextColorDescription:
    'Izaberite boju naslova i teksta. Predlog daje bolji kontrast.',
  comicFonts: 'Fontovi stripa',
  comicFontsDescription:
    'Izaberite odvojeno font za naslov i tekst ispod slika. Promena fonta je besplatna.',
  comicTitleFont: 'Font naslova',
  comicBodyFont: 'Font teksta ispod slika',
  hexColor: 'HEX boja',
  useSuggestedTextColor: 'Primeni predlozenu boju slova',
  storyteller: 'Pripovedač',
  logout: 'Odjavi se',
  spendingCreditsDialog: `Generisanje priče će vas koštati ${REQUIRED_CREDITS.GENERATE_DIALOG} token.`,
  imageCountText: {
    1: 'jednu sliku',
    2: 'dve slike',
    3: 'tri slike',
    4: 'četiri slike',
  },
  tokenCountText: {
    1: 'jedan token',
    2: 'dva tokena',
    3: 'tri tokena',
    4: 'četiri tokena',
  },
  imageStepCreditNotice:
    'Trenutno će SciComic generisati __IMAGE_COUNT__. To će koštati __TOKEN_COUNT__ tek kada kliknete na finalno generisanje.',
  imageStepFreeNotice:
    'Sve slike su već dostupne. Za njih neće biti dodatno potrošeni tokeni.',
  regenerateFrameCreditNotice:
    'Ponovno generisanje ovog frame-a troši __CREDITS__ token.',
  notEnoughCreditsDialog: `Potrebno vam je najmanje ${REQUIRED_CREDITS.GENERATE_DIALOG} kredit da biste generisali dijalog stripa.`,
  notEnoughCreditsComic:
    'Potrebno vam je najmanje __TOKEN_COUNT__ za generisanje __IMAGE_COUNT__.',
  disclaimer: 'SciComic može da pravi greške. Proveri važne informacije.',
};

export default sr;
